/**
 * @module Constants
 */
const Constants = (() => {
  return {
    PortalDivId: "div-portal",
    ClassPrimaryButtonBorder: "button-primary-w-border",
    PopUpPortalDivId: "div-popup-portal",
    FeedPortalDivId: "div-feed-portal",
    ProfilePictureName: "profile-picture",
    DefaultValuesDocumentId: "default-values",
    ProfileHeadLineEmptyName: "<insert headline>",
    ProfileCountryEmptyName: "<insert country>",
    ProfilePostalCodeEmptyName: "<insert psotalcode>",
    DefaultValueLanguageId: "en",
  };
})();

export { Constants };
